import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import ContentfulButton from '../Utilities/Buttons/ContentfulButton'

function BlockCard({ data, useDivOutterContainer }) {
  const {
    images,
    hideImageMobile,
    padImage,
    theme,
    backgroundImage,
    overlay,
    alignTextContent,
    headline,
    buttons,
    afterText,
    disclaimerText,
    subText
  } = data

  const overlayClass = {
    Wave: 'wave',
    Fade: 'fade'
  }[overlay]

  let overlayComp
  if (overlayClass) {
    overlayComp = <div className={`overlay ${overlayClass}`} />
  }

  let bgImageComp
  let noBackgroundClass = ''
  if (backgroundImage) {
    bgImageComp = (
      <GatsbyImage
        className="background"
        image={getImage(backgroundImage)}
        alt={backgroundImage.altText}
      />
    )
  } else {
    noBackgroundClass = 'no-background'
  }

  let imageComp
  const hasImageClass = `${images ? 'has' : 'no'}-image`
  const hideImageMobileClass = hideImageMobile ? 'hide-mobile' : ''

  if (images && images.length === 1) {
    const padImageClass = padImage ? 'pad' : ''
    images.map(img => {
      if (getImage(img)) {
        return (imageComp = (
          <GatsbyImage
            className={`image ${padImageClass} ${hideImageMobileClass}`}
            image={getImage(img)}
            alt={img.altText}
          />
        ))
      }
      return (imageComp = (
        <img
          className={`image ${padImageClass} ${hideImageMobileClass}`}
          src={img?.image?.file?.url}
          srcSet={img?.image?.file?.url}
          alt={img.altText}
        />
      ))
    })
  }

  /* eslint-disable react/no-danger */
  let headlineComp
  if (headline && headline.trim().length) {
    headlineComp = <h2 className="headline" dangerouslySetInnerHTML={{ __html: headline }} />
  }

  let subTextComp
  if (subText && subText.subText.trim().length) {
    subTextComp = <p className="subtext" dangerouslySetInnerHTML={{ __html: subText?.subText }} />
  }

  let afterTextComp
  if (afterText && afterText.trim().length) {
    afterTextComp = <p className="after" dangerouslySetInnerHTML={{ __html: afterText }} />
  }

  const contentAlignClass = alignTextContent.toLowerCase()

  const outterClasses = ['container__outter', contentAlignClass]

  if (theme && theme !== 'Dark Blue (Default)') {
    outterClasses.push(theme.toLowerCase().replaceAll(' ', '-'))
  }

  let disclaimerComp
  if (disclaimerText?.disclaimerText)
    disclaimerComp = (
      <p
        className="disclaimer"
        dangerouslySetInnerHTML={{ __html: disclaimerText.disclaimerText }}
      />
    )

  const content = (
    <div className={outterClasses.join(' ')}>
      <div className="container__imgs">
        {bgImageComp}
        {imageComp}
        {overlayComp}
      </div>
      <div className="container__inner">
        <div className={`content ${hasImageClass} ${hideImageMobileClass} ${noBackgroundClass}`}>
          <div className="intro">
            {headlineComp}
            {subTextComp}
          </div>
          <div className="buttons">
            {(buttons || []).map((button, index) => (
              /* eslint-disable react/no-array-index-key */
              <ContentfulButton data={button} key={index} />
            ))}
          </div>
          {afterTextComp}
          {disclaimerComp}
        </div>
      </div>
    </div>
  )
  if (useDivOutterContainer)
    return <div className={`block-card ${contentAlignClass}`}>{content}</div>

  return <section className={`block-card ${contentAlignClass}`}>{content}</section>
}

BlockCard.defaultProps = {
  useDivOutterContainer: false
}

BlockCard.propTypes = {
  data: PropTypes.object.isRequired,
  useDivOutterContainer: PropTypes.bool
}

export default BlockCard
